import React from 'react';
import DealCard from './DealCard';

import img1 from '../../assest/crd1.jpeg';
import img2 from '../../assest/crd2.jpg';
import img3 from '../../assest/crd3.jpg';

const dealsData = [
  {
    image: img1,
    title: 'Cheap Flights, Bigger Trips',
    subtitle: 'Compare fares across airlines and fly for less',
    type: 'FLIGHT',
  },
  {
    image: img2,
    title: 'From Asia to the World',
    subtitle: 'Save and explore global destinations by bus',
    type: 'BUS',
  },
  {
    image: img3,
    title: 'Get Up to 50% Off*',
    subtitle: 'Huge savings on hotels, homestays & hourly stays',
    type: 'HOTEL',
  },
];

const DealsList = ({ activeTab = 'ALL' }) => {
  const deals =
    activeTab === 'ALL'
      ? dealsData
      : dealsData.filter((deal) => deal.type === activeTab);

  if (deals.length === 0) {
    return (
      <div className="text-center py-10 text-ink-400 text-sm">
        No deals available in this category right now.
      </div>
    );
  }

  return (
    <div className="mt-8 grid grid-cols-1 md:grid-cols-3 gap-6">
      {deals.map((deal, index) => (
        <DealCard key={index} {...deal} />
      ))}
    </div>
  );
};

export default DealsList;
